// Zentrale Konfiguration für alle Umgebungen.
// Nicht-geheime Werte leben hier (versioniert), Secrets kommen aus .env / Key Vault.

export type Environment = 'development' | 'staging' | 'production';

export interface EnvironmentConfig {
  apiBaseUrl: string;
  frontendUrl: string;
  environment: Environment;
  debug: boolean;
  appName: string;
}

const ENVIRONMENT_CONFIGS: Record<Environment, EnvironmentConfig> = {
  development: {
    apiBaseUrl: 'http://localhost:8000/api',
    frontendUrl: 'http://localhost:3000',
    environment: 'development',
    debug: true,
    appName: 'Windpark Kalkulator (Dev)',
  },
  staging: {
    apiBaseUrl: 'https://windpark-backend-api.azurewebsites.net/api',
    frontendUrl: 'https://gray-mushroom-0c329df03.2.azurestaticapps.net',
    environment: 'staging',
    debug: true,
    appName: 'Windpark Kalkulator (Staging)',
  },
  production: {
    apiBaseUrl: 'https://stroemcraft.com/api',
    frontendUrl: 'https://stroemcraft.com',
    environment: 'production',
    debug: false,
    appName: 'Windpark Kalkulator',
  },
} as const;

export const getCurrentEnvironment = (): Environment => {
  const env = import.meta.env.VITE_ENVIRONMENT as Environment;
  return env && env in ENVIRONMENT_CONFIGS ? env : 'development';
};

const config: EnvironmentConfig = ENVIRONMENT_CONFIGS[getCurrentEnvironment()];

if (!config.apiBaseUrl?.startsWith('http')) {
  throw new Error(
    `Ungültige apiBaseUrl "${config.apiBaseUrl}" für Umgebung "${config.environment}".`,
  );
}

export default config;
